import { render, staticRenderFns } from "./DitchnetworkPassport.vue?vue&type=template&id=19c9e2f4&scoped=true"
import script from "./DitchnetworkPassport.vue?vue&type=script&lang=js"
export * from "./DitchnetworkPassport.vue?vue&type=script&lang=js"
import style0 from "./DitchnetworkPassport.vue?vue&type=style&index=0&id=19c9e2f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c9e2f4",
  null
  
)

export default component.exports